module.exports = __webpack_public_path__ + "static/media/case2.53c1e7ae.png";